const schedulesOption = [
  {
    id: 1,
    value: 1,
    label: '1',
  },
  {
    id: 2,
    value: 2,
    label: '2',
  },
  {
    id: 3,
    value: 3,
    label: '3',
  },
  {
    id: 4,
    value: 4,
    label: '4',
  },
  {
    id: 5,
    value: 5,
    label: '5',
  },
  {
    id: 6,
    value: 6,
    label: '6',
  },
  {
    id: 7,
    value: 7,
    label: '7',
  },
  {
    id: 8,
    value: 8,
    label: '8',
  },
  {
    id: 9,
    value: 9,
    label: '9',
  },
  {
    id: 10,
    value: 10,
    label: '10',
  },
  {
    id: 11,
    value: 11,
    label: '11',
  },
  {
    id: 12,
    value: 12,
    label: '12',
  },
  {
    id: 13,
    value: 13,
    label: '13',
  },
  {
    id: 14,
    value: 14,
    label: '14',
  },
  {
    id: 15,
    value: 15,
    label: '15',
  },
  {
    id: 16,
    value: 16,
    label: '16',
  },
  {
    id: 17,
    value: 17,
    label: '17',
  },
  {
    id: 18,
    value: 18,
    label: '18',
  },
  {
    id: 19,
    value: 19,
    label: '19',
  },
  {
    id: 20,
    value: 20,
    label: '20',
  },
  {
    id: 21,
    value: 21,
    label: '21',
  },
  {
    id: 22,
    value: 22,
    label: '22',
  },
  {
    id: 23,
    value: 23,
    label: '23',
  },
  {
    id: 0,
    value: 0,
    label: '00',
  },
];

export default schedulesOption;
